import type { Reaction, ReactionCounts } from './post-service';

const REACTION_ORDER = [
  'love',
  'like',
  'dislike',
  'laugh',
  'wow',
  'vomit',
  'fire',
  'trash',
] as const satisfies readonly Reaction[];

export function getTopUniqueReactions(
  counts: ReactionCounts,
  limit = 3,
): Reaction[] {
  return REACTION_ORDER.filter((reaction) => counts[reaction] > 0)
    .sort((firstReaction, secondReaction) => {
      const countDelta = counts[secondReaction] - counts[firstReaction];

      if (countDelta !== 0) {
        return countDelta;
      }

      return (
        REACTION_ORDER.indexOf(firstReaction) -
        REACTION_ORDER.indexOf(secondReaction)
      );
    })
    .slice(0, limit);
}
